import type { SpreadLevel } from "@cede/types";

const SPREAD_WARNING_DELTA = 0.1;

export const SPREAD_TOOLTIP_TEXT =
  "This indicator reflects the current spread compared to this campaign's Volume Target. Spread tolerance varies by campaign.";

export const getSpreadIndicatorLevel = (
  spread: number | undefined,
  threshold: number | null | undefined,
): SpreadLevel | undefined => {
  if (spread === undefined || threshold == null) return undefined;
  if (spread >= threshold) return "bad";
  if (spread >= threshold - SPREAD_WARNING_DELTA) return "warning";
  return "good";
};

export const getSpreadColorClass = (
  spread: number | undefined,
  threshold: number | null | undefined,
): string | undefined => {
  const level = getSpreadIndicatorLevel(spread, threshold);
  if (!level) return undefined;
  if (level === "bad") return "text-cede-error";
  if (level === "warning") return "text-cede-warning";
  return "text-cede-success";
};
